module.exports = __webpack_public_path__ + "img/none-icon-menu.12d9c8f9.svg";